import React, { useContext, useEffect, useState } from "react"
import {
  Button,
  ModalBody,
  Form,
  FormGroup,
  Input,
  Row,
  Col,
  Card,
  Label,
  Spinner,
} from "reactstrap"
import { DataContext } from "../../context/dataContext"
import moment from "moment"
import apiHandler from "../../common/config/apiHandler"
// import { CardElement, useElements, useStripe } from "@stripe/react-stripe-js"
import createIntent from "../../common/config/createIntent"
import toast from "react-hot-toast"
import ShiftBooking from "../../common/config/shift-booking"
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import { Navigate, useNavigate } from "react-router-dom"
import useValidation from "../../hooks/useValidation"
import domainUrl from "../../common/config/domainUrl"
import StripeElement from "../../components/Stripe/StripeElement"

const TransferBookingModal = ({ setActiveTab, public_key }) => {
  const navigate = useNavigate()
  const { validate, errors, setErrors } = useValidation()

  const { airports, bookingDetails, subscribeKey, fetchSubscribeKey } =
    useContext(DataContext)

  const [quoteData, setQuoteData] = useState({})
  const [loadingQuote, setLoadingQuote] = useState(false)
  const [loadingCompany, setLoadingCompany] = useState(false)

  const [quoteDifference, setQuoteDifference] = useState(0)
  const [loadingPayment, setLoadingPayment] = useState(false)
  const [submitLoading, setSubmitLoading] = useState(false)
  const [extraCharges, setExtraCharges] = useState(0)
  const [payableAmount, setPayableAmount] = useState(0)
  const [payment_intent, setPayment_Intent] = useState("")
  const [paymentOption, setPaymentOption] = useState("")
  const [clientSecret, setClient_Secret] = useState("")
  const [transactionID, setTransactionID] = useState("")
  const [availableCompanies, setAvailableCompanies] = useState([])
  const [checkbox, setCheckbox] = useState({
    company_email: true,
    customer_email: true,
  })
  const [transferData, setTransferData] = useState({
    toCompany: "",
    fromCompany: "",
    fromAirport: "",
    departureDate: "",
    departureTime: "",
    arrivalDate: "",
    arrivalTime: "",
    company_email: checkbox?.company_email,
    customer_email: checkbox?.customer_email,
    sms: checkbox?.sms,
  })

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
  })

  const handleCheckboxChange = e => {
    const { name, type, value } = e.target
    setCheckbox(prevData => ({
      ...prevData,
      [name]:
        type === "checkbox" ? (prevData[name] === "1" ? "0" : "1") : value,
    }))
  }

  useEffect(() => {
    const currentDetail = bookingDetails?.bookingDetails?.find(
      detail => detail?.is_current === true || detail?.is_current === 1
    )

    if (currentDetail) {
      setTransferData(prevState => ({
        ...currentDetail,
        fromCompany: currentDetail?.company?.name,
        fromAirport: currentDetail?.airport?.name,
        departureDate: currentDetail?.departure_date,
        departureTime: currentDetail?.departure_time,
        arrivalDate: currentDetail?.arrival_date,
        arrivalTime: currentDetail?.arrival_time,
      }))
      setFormData({
        firstName: currentDetail?.customer?.first_name,
        lastName: currentDetail?.customer?.last_name,
      })
      setExtraCharges(bookingDetails?.site?.amend_charge)
    }
  }, [bookingDetails])

  useEffect(() => {
    if (paymentOption == "stripe-dashboard") {
      const currentDetail = bookingDetails?.bookingDetails?.find(
        detail => detail?.is_current === true || detail?.is_current === 1
      )

      setTransactionID(currentDetail?.payment?.transaction_id)
    }
  }, [paymentOption])

  const handleChange = e => {
    const { name, type, value } = e.target
    setTransferData(prevData => ({
      ...prevData,
      [name]:
        type === "checkbox" ? (prevData[name] === "1" ? "0" : "1") : value,
    }))
    const ErrorEmpty = { ...errors, [name]: "" }
    setErrors(ErrorEmpty)
  }
  const handleAirportChange = async e => {
    const selectedAirportId = e.target.value
    setLoadingCompany(true)
    setTransferData(prevState => ({
      ...prevState,
      toAirport: selectedAirportId,
    }))
    const ErrorEmpty = { ...errors, [e.target.name]: "" }
    setErrors(ErrorEmpty)

    try {
      if (selectedAirportId) {
        const response = await apiHandler({
          endpoint: `/backend/companies/getCompaniesByAirportId?airport_code=${selectedAirportId}&&key=${subscribeKey}`,
          method: "GET",
          options: {
            "x-access-token": localStorage.getItem("token"),
          },
        })
        if (response?.code === 200) {
          setLoadingCompany(false)

          setAvailableCompanies(response?.data?.rows || [])
          if (response?.data?.rows?.length === 0) {
            toast.error("There are no companies in this airport")
          }
        } else {
          toast.error(
            response?.message ||
              "Failed to fetch companies. Please try again later."
          )
          setLoadingCompany(false)
        }
      }
    } catch (error) {
      console.error("Error fetching companies:", error)
      setLoadingCompany(false)

      alert("Network error occurred while fetching companies.")
    }
  }

  useEffect(() => {
    if (transferData) {
      fetchSubscribeKey("", bookingDetails?.site_id)
    }
  }, [])

  useEffect(() => {
    setPayableAmount(
      parseFloat(quoteDifference) +
        parseFloat(extraCharges) -
        parseFloat(transferData.payment?.amount)
    )
  }, [quoteDifference, extraCharges, transferData.payment?.amount])

  const handleGetQuote = async data => {
    const {
      departureDate,
      departureTime,
      arrivalDate,
      arrivalTime,
      toCompany,
      toAirport,
    } = data
    const validationErrors = validate(transferData, "transferBooking")
    if (!validationErrors) {
      return
    }
    setLoadingQuote(true)
    try {
      const params = new URLSearchParams({
        site_id: bookingDetails?.site_id,
        airport: transferData?.toAirport,
        departure: moment(
          `${transferData?.departureDate} ${transferData?.departureTime}`
        ).format("DD-MM-YYYY HH:mm"),
        arrival: moment(
          `${transferData?.arrivalDate} ${transferData?.arrivalTime}`
        ).format("DD-MM-YYYY HH:mm"),
        company_id: transferData?.toCompany,
      })

      const response = await apiHandler({
        endpoint2: `/extendProduct?${params.toString()}`,
        method: "GET",
      })

      if (response?.response_code === 200) {
        setQuoteData(response?.data)
        setQuoteDifference(response?.data?.price || 0)
        setLoadingQuote(false)
      } else {
        toast.error(
          response?.message || "Failed to fetch quote. Please try again later."
        )
        setLoadingQuote(false)
      }
    } catch (error) {
      setLoadingQuote(false)
      console.error("Error fetching quote:", error)
      alert("Network error occurred while fetching the quote.")
    } finally {
      setLoadingQuote(false)
    }
  }
  const handleCreateIntent = async () => {
    setLoadingPayment(true)
    // const amountInCents = Math.round(payableAmount * 100)
    if (payableAmount <= 0) {
      toast.error("payable amount must be greater than 0")
    }

    try {
      if (subscribeKey) {
        const paymentIntentResponse = await createIntent({
          key: subscribeKey,
          amount: payableAmount.toFixed(2),
          description: bookingDetails?.multi_mode,
        })

        if (paymentIntentResponse?.client_secret) {
          setClient_Secret(paymentIntentResponse?.client_secret)
          setPayment_Intent(paymentIntentResponse?.payment_intent)
          setLoadingPayment(false)
        } else {
          setClient_Secret("")
          setPayment_Intent("")
          alert("Failed to create payment intent. Please try again.")
          setLoadingPayment(false)
        }
      }
    } catch (error) {
      console.error("Payment error:", error)
      setLoadingPayment(false)
      toast.error(
        "Error creating payment intent. Please try again. Error: " +
          error?.message
      )
    } finally {
      setLoadingPayment(false)
    }
  }

  const handleSubmit = async transaction_id => {
    try {
      const user = JSON.parse(localStorage.getItem("user"))
      setLoadingPayment(true)

      const shiftResponse = await ShiftBooking({
        key: subscribeKey,
        user_id: String(user?.id),
        site_id: transferData?.site_id,
        reference_no: bookingDetails?.reference_no,
        company_id: transferData?.toCompany,
        airport: transferData?.toAirport,
        departure: moment(
          `${transferData.departureDate} ${transferData.departureTime}`
        ).format("DD-MM-YYYY HH:mm"),
        arrival: moment(
          `${transferData.arrivalDate} ${transferData.arrivalTime}`
        ).format("DD-MM-YYYY HH:mm"),
        amount: quoteData.price,
        extra_amount: extraCharges,
        payment_type: paymentOption,
        transaction_id: transaction_id,
        payment_intent_id: transaction_id,
        sms: checkbox?.sms,
        customer_email: checkbox?.customer_email,
        company_email: checkbox?.company_email,
      })

      if (shiftResponse?.response_code == 200) {
        navigate("/allBookings")
        setTimeout(() => {
          window.location.reload()
        }, 100)
        toast.success(shiftResponse?.message)
        setActiveTab("")
        setLoadingPayment(false)
        setSubmitLoading(false)
      } else {
        setLoadingPayment(false)
        setSubmitLoading(false)
      }
    } catch (error) {
      setLoadingPayment(false)
      setSubmitLoading(false)
      toast.error(error?.errors || "An error occurred. Please try again.")
    }
  }

  const handleWorldPay = async () => {
    const user = JSON.parse(localStorage.getItem("user"))
    setLoadingPayment(true)

    try {
      const response = await apiHandler({
        endpoint: "/backend/payment/create-worldpay-session",
        method: "POST",
        options: {
          "x-access-token": localStorage.getItem("token"),
        },
        data: {
          type: "shiftBooking",
          key: subscribeKey,
          extra_amount: extraCharges || 0,
          site_id: bookingDetails?.site_id,
          company_id: transferData?.toCompany,
          amount: payableAmount,
          airport: transferData?.toAirport,
          departure: moment(
            `${transferData.departureDate} ${transferData.departureTime}`
          ).format("DD-MM-YYYY HH:mm"),
          arrival: moment(
            `${transferData.arrivalDate} ${transferData.arrivalTime}`
          ).format("DD-MM-YYYY HH:mm"),
          multi_mode_reference_no: bookingDetails?.multi_mode,
          reference_no: bookingDetails?.reference_no,
          payment_type: paymentOption,
          user_id: String(user?.id),
          sms: true,
          customer_email: true,
          company_email: true,
          notify: `${domainUrl}/worldpay-notify?multi_mode_reference_no=${bookingDetails?.multi_mode}&reference_no=${bookingDetails?.reference_no}`,
          response: `${domainUrl}/worldpay-response?multi_mode_reference_no=${bookingDetails?.multi_mode}&reference_no=${bookingDetails?.reference_no}`,
          cancel: `${domainUrl}/worldpay-cancel?multi_mode_reference_no=${bookingDetails?.multi_mode}&reference_no=${bookingDetails?.reference_no}`,
        },
      })

      if (response) {
        if (typeof window !== "undefined") {
          setLoadingPayment(false)
          window.location.href = response?.data?.redirectUrl
          // console.log("host--------------", domainUrl);
        }
      }
    } catch (error) {
      setLoadingPayment(false)
      toast.error(error.response?.data?.message, { duration: 3000 })
    }
  }


  return (
    <Card>
      <ModalBody style={{ overflowY: "visible" }}>
        <div>
          <h6 style={{ fontWeight: "600" }}> Transfer Booking</h6>
        </div>
        <Form>
          <Row form>
            <Col md={6}>
              <FormGroup>
                <label for="fromAirport" style={{ fontSize: "11px" }}>
                  From Airport *
                </label>
                <Input
                  type="text"
                  name="fromAirport"
                  id="fromAirport"
                  value={transferData?.fromAirport}
                  invalid={errors.fromAirport}
                  disabled
                  style={{ fontSize: "11px" }}
                  className=" form-input "
                />
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <label for="fromCompany" style={{ fontSize: "11px" }}>
                  From Company *
                </label>
                <Input
                  type="text"
                  name="fromCompany"
                  id="fromCompany"
                  value={transferData?.fromCompany}
                  invalid={errors.fromCompany}
                  disabled
                  style={{ fontSize: "11px" }}
                  className=" form-input "
                />
              </FormGroup>
            </Col>
          </Row>
          <p style={{ border: "1px grey" }}></p>
          <Row form>
            <Col md={6}>
              <FormGroup>
                <label for="toAirport" style={{ fontSize: "11px" }}>
                  To Airport *
                </label>
                <Input
                  type="select"
                  className=" form-input "
                  name="toAirport"
                  id="toAirport"
                  style={{ fontSize: "11px" }}
                  invalid={errors.toAirport}
                  onChange={handleAirportChange}
                >
                  <option value="">Select Airport</option>
                  {airports?.map(airport => (
                    <option key={airport.id} value={airport.code}>
                      {airport.name}
                    </option>
                  ))}
                </Input>
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <label for="toCompany" style={{ fontSize: "11px" }}>
                  To Company *
                </label>
                <Input
                  type="select"
                  className=" form-input "
                  name="toCompany"
                  id="toCompany"
                  style={{ fontSize: "11px" }}
                  onChange={handleChange}
                  invalid={errors.toCompany}
                >
                  <option value="">
                    {loadingCompany ? "loading..." : "Select Company"}
                  </option>
                  {availableCompanies?.[0]?.companies?.map(company => (
                    <option key={company.id} value={company.id}>
                      {company.name}
                    </option>
                  ))}
                </Input>
              </FormGroup>
            </Col>
          </Row>
          <Row form>
            <Col md={6}>
              <FormGroup>
                <label for="departDate" style={{ fontSize: "11px" }}>
                  Depart Date *
                </label>
                <DatePicker
                  selected={
                    transferData?.departureDate
                      ? new Date(transferData?.departureDate)
                      : null
                  }
                  style={{ fontSize: "11px" }}
                  onChange={date =>
                    handleChange({
                      target: {
                        name: "departureDate",
                        value: moment(date).format("YYYY-MM-DD"),
                      },
                    })
                  }
                  minDate={new Date()}
                  className="form-input  f-11"
                  dateFormat="dd-MMM-yyyy"
                  required
                />
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <label for="dropOffTime" style={{ fontSize: "11px" }}>
                  Drop-Off Time *
                </label>
                <DatePicker
                  selected={
                    transferData?.departureTime
                      ? new Date(`1970-01-01T${transferData?.departureTime}`)
                      : null
                  }
                  onChange={time =>
                    handleChange({
                      target: {
                        name: "departureTime",
                        value: time.toTimeString().slice(0, 5),
                      },
                    })
                  }
                  showTimeSelect
                  showTimeSelectOnly
                  timeIntervals={15}
                  timeFormat="HH:mm"
                  dateFormat="HH:mm"
                  className="form-input  f-11"
                  required
                />
              </FormGroup>
            </Col>
          </Row>
          <Row form>
            <Col md={6}>
              <FormGroup>
                <label for="returnDate" style={{ fontSize: "11px" }}>
                  Return Date *
                </label>
                <DatePicker
                  selected={
                    transferData?.arrivalDate
                      ? new Date(transferData?.arrivalDate)
                      : null
                  }
                  style={{ fontSize: "11px" }}
                  onChange={date =>
                    handleChange({
                      target: {
                        name: "arrivalDate",
                        value: moment(date).format("YYYY-MM-DD"),
                      },
                    })
                  }
                  minDate={new Date()}
                  className="form-input  f-11"
                  dateFormat="dd-MMM-yyyy"
                  required
                />
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <label for="pickUpTime" style={{ fontSize: "11px" }}>
                  Pick-Up Time *
                </label>
                <DatePicker
                  selected={
                    transferData?.arrivalTime
                      ? new Date(`1970-01-01T${transferData?.arrivalTime}`)
                      : null
                  }
                  onChange={time =>
                    handleChange({
                      target: {
                        name: "arrivalTime",
                        value: time.toTimeString().slice(0, 5),
                      },
                    })
                  }
                  showTimeSelect
                  showTimeSelectOnly
                  timeIntervals={15}
                  timeFormat="HH:mm"
                  dateFormat="HH:mm"
                  className="form-input  f-11"
                  required
                />
              </FormGroup>
            </Col>
          </Row>
          <Button
            color="warning"
            className="mt-1"
            size="sm"
            onClick={handleGetQuote}
            style={{ width: "150px" }}
            disabled={loadingQuote}
          >
            {loadingQuote ? <Spinner size="sm" /> : "Get Transfer Quote"}
          </Button>
          {quoteData?.price && (
            <>
              <h5 className="mt-2">Quote Details</h5>
              {Number(quoteData.price) >
              Number(transferData?.payment?.amount) ? (
                <div className="alert alert-success" role="alert">
                  New Quote Amount {Number(quoteData.price).toFixed(2)} is
                  greater than Quoted Amount{" "}
                  {Number(transferData?.payment?.amount).toFixed(2)}. <br />
                  Customer already paid{" "}
                  {(
                    (parseFloat(transferData?.payment.amount) || 0) +
                    (parseFloat(transferData?.payment.cancellation_charges) ||
                      0) +
                    (parseFloat(transferData?.payment.sms_charges) || 0) +
                    (parseFloat(transferData?.payment.levy_charges) || 0) +
                    (parseFloat(transferData?.payment.valet_charges) || 0) +
                    (parseFloat(transferData?.payment.admin_charges) || 0) +
                    (parseFloat(transferData?.payment.extra_charges) || 0) -
                    (parseFloat(transferData?.payment.discount) || 0)
                  ).toFixed(2)}
                </div>
              ) : (
                <div className="alert alert-warning" role="alert">
                  New Quote Amount {Number(quoteData.price).toFixed(2)} is less
                  than or equal to Quoted Amount{" "}
                  {Number(transferData?.payment?.amount).toFixed(2)}. <br />
                  Customer already paid{" "}
                  {(
                    (parseFloat(transferData?.payment.amount) || 0) +
                    (parseFloat(transferData?.payment.cancellation_charges) ||
                      0) +
                    (parseFloat(transferData?.payment.sms_charges) || 0) +
                    (parseFloat(transferData?.payment.levy_charges) || 0) +
                    (parseFloat(transferData?.payment.valet_charges) || 0) +
                    (parseFloat(transferData?.payment.admin_charges) || 0) +
                    (parseFloat(transferData?.payment.extra_charges) || 0) -
                    (parseFloat(transferData?.payment.discount) || 0)
                  ).toFixed(2)}
                </div>
              )}

              <div className="d-flex justify-content-between">
                <Row>
                  <Col md={6}>
                    <FormGroup>
                      <label for="quoteDifference">Quote Difference *</label>
                      <Input
                        type="number"
                        name="quoteDifference"
                        id="quoteDifference"
                        value={(
                          Number(quoteDifference) -
                          Number(transferData?.payment?.amount || 0)
                        ).toFixed(2)}
                        onChange={e =>
                          setQuoteDifference(Number(e.target.value))
                        }
                        className="border-secondary"
                        readOnly
                      />
                    </FormGroup>
                  </Col>
                  {/* <Col md={6}>
                    <FormGroup>
                      <label for="extraCharges">Extra Charges*</label>
                      <Input
                        type="number"
                        name="extraCharges"
                        id="extraCharges"
                        value={parseFloat(extraCharges).toFixed(2)}
                        onChange={e =>
                          setExtraCharges(parseFloat(e.target.value))
                        }
                        className=""
                      />
                    </FormGroup>
                  </Col> */}
                  <Col md={6}>
                    <FormGroup>
                      <label for="extraCharges">Extra Charges*</label>
                      <Input
                        type="text"
                        name="extraCharges"
                        id="extraCharges"
                        value={extraCharges}
                        onChange={e => {
                          const value = e.target.value
                          if (/^\d*\.?\d*$/.test(value) || value === "") {
                            setExtraCharges(value)
                          }
                        }}
                        className="border-secondary"
                        placeholder="Enter extra charges"
                      />
                    </FormGroup>
                  </Col>
                </Row>
              </div>

              <div className="d-flex justify-content-between">
                <Col md={12}>
                  <FormGroup>
                    <label for="payableAmount">Payable Amount*</label>
                    <Input
                      type="number"
                      name="payableAmount"
                      id="payableAmount"
                      value={Number(payableAmount).toFixed(2)}
                      className="border-secondary"
                      disabled
                    />
                  </FormGroup>
                </Col>
              </div>

              <StripeElement
                public_key={public_key}
                paymentOption={paymentOption}
                setPaymentOption={setPaymentOption}
                payment_intent={payment_intent}
                clientSecret={clientSecret}
                handleCreateIntent={handleCreateIntent}
                transactionID={transactionID}
                setTransactionID={setTransactionID}
                setLoadingPayment={setLoadingPayment}
                submitLoading={submitLoading}
                extraCharges={payableAmount}
                setSubmitLoading={setSubmitLoading}
                handleComplete={handleSubmit}
                apiTag={bookingDetails?.bookingDetails[0]?.company?.sku_tag}
                formData={formData}
              />

              <Row form className="mt-3">
                <Row>
                  <Col md={6}>
                    <FormGroup check>
                      <Label check>
                        <Input
                          type="checkbox"
                          className="border-primary"
                          name="customer_email"
                          checked={
                            checkbox?.customer_email == "1" ? true : false
                          }
                          onClick={handleCheckboxChange}
                          style={{ fontSize: "11px" }}
                        />{" "}
                        Send Customer Email
                      </Label>
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup check>
                      <Label check>
                        <Input
                          type="checkbox"
                          className="border-primary"
                          name="company_email"
                          checked={
                            checkbox?.company_email == "1" ? true : false
                          }
                          onClick={handleCheckboxChange}
                          style={{ fontSize: "11px" }}
                        />{" "}
                        Send Company Email
                      </Label>
                    </FormGroup>
                  </Col>
                </Row>

                <Col md={12}>
                  <FormGroup check>
                    <Label check>
                      <Input
                        type="checkbox"
                        className="border-primary"
                        name="sms"
                        checked={checkbox?.sms == "1" ? true : false}
                        onClick={handleCheckboxChange}
                        style={{ fontSize: "11px" }}
                      />{" "}
                      SMS Confirmation to Customer
                    </Label>
                  </FormGroup>
                </Col>
              </Row>

              <Button
                type="button"
                color="primary"
                onClick={() => {
                  if (paymentOption == "worldpay") {
                    handleWorldPay()
                  } else {
                    if (paymentOption == "") {
                      toast.error("Please select a payment option", {
                        duration: 3000,
                      })
                      return
                    } else {
                      setSubmitLoading(true)
                    }
                  }
                }}
                size="sm"
                className="me-3 mt-2"
                style={{ width: "80px" }}
                disabled={loadingPayment}
              >
                {loadingPayment ? <Spinner size="sm" /> : "Submit"}
              </Button>
              <Button
                color="danger"
                onClick={() => setActiveTab("")}
                size="sm"
                className="mt-2"
              >
                Cancel
              </Button>
            </>
          )}
        </Form>
      </ModalBody>
    </Card>
  )
}

export default TransferBookingModal
